// extracted by mini-css-extract-plugin
export default {"labelWithTooltip":"EventQrConfirmationWindowInput_labelWithTooltip__ZyzZv"};